
import React from "react";
import { MessageCircle } from "lucide-react";

const ContactSection = () => {
  return (
    <section className="py-16 container">
      <div className="bg-gradient-to-br from-earth-50 to-earth-100 rounded-xl p-8 md:p-12 text-center max-w-3xl mx-auto">
        <MessageCircle className="w-12 h-12 text-eco-500 mb-6 mx-auto" />
        <h2 className="text-3xl font-bold mb-4 text-eco-700">Grow With Us</h2>
        <p className="text-lg mb-8">
          Whether you're a business owner, community leader, or simply someone who 
          cares about sustainability, we'd love to hear from you.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="mailto:chat@ourcelium.co.uk">
            <button className="w-full sm:w-auto bg-eco-500 hover:bg-eco-600 text-white font-medium py-3 px-6 rounded-md transition-colors">
              Contact Us
            </button>
          </a>
          <a href="/submit">
            <button className="w-full sm:w-auto border border-eco-500 text-eco-500 hover:bg-eco-500 hover:text-white font-medium py-3 px-6 rounded-md transition-colors">
              Add a Listing
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
